export default __webpack_public_path__ + "static/realworld-385efe1b2fc8bd82f005b22bffc9d3bc.png";